import React, { useState, ChangeEvent } from 'react';
import Input from 'src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/Input/Input';
import { CommonEmailDomains } from '../../constants';
import './EmailAutocompleteDomainSuggestion.scss';

interface EmailAutocompleteInputProps {
  value: string;
  onChange: (name: string | null, value: string, validationCharLength: string | null) => void;
}

const EmailAutocompleteDomainSuggestion: React.FC<
  EmailAutocompleteInputProps
> = ({ value, onChange, ...props }) => {
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>(value);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;

    setInputValue(input);

    const [localPart, domainPart] = input.split('@');

    if (domainPart !== undefined) {
      const matches = CommonEmailDomains
        .filter(d => d.startsWith(domainPart) && d !== domainPart)
        .map(d => `${localPart}@${d}`);

      setSuggestions(matches);
    } else {
      setSuggestions([]);
    }

    onChange(
      e.target.name || e.target.getAttribute('name'),
      input,
      e.target.getAttribute('data_validation_char_length'),
    );
  };

  const handleSuggestionClick = (e: any, suggestion: string) => {
    setInputValue(suggestion);
    onChange(
      e.target.name || e.target.getAttribute('name'),
      suggestion,
      e.target.getAttribute('data_validation_char_length'),
    );
    setSuggestions([]);
  };

  return (
    <div className="email-autocomplete-domain-suggestion">
      <Input
        className="login-email"
        placeholder="email address"
        type="email"
        required={true}
        onChange={handleChange}
        name="email"
        value={inputValue}
        {...props}
      />

      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((suggestion) => (
            <li
              key={suggestion}
              onClick={e => handleSuggestionClick(e, suggestion)}
              className="list-item"
              {...props}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EmailAutocompleteDomainSuggestion;
